/**
 * How long each preview holds before the carousel advances.
 *
 * Long enough to read a frame, short enough that a two-output preset shows both
 * within a glance at a scrolling grid. Shared with gen-ai-web's
 * `src/constants/carousel.ts` so the same preset cycles at the same rate on
 * both surfaces.
 */
export const CAROUSEL_INTERVAL_MS = 1800;
